import {observable} from "mobx";
import {RelatorioService} from "../../../services";
import fileDownload from "../../comum/components/FileDownload";
import moment from "moment";
import {toast} from "react-toastify";

export default class MotsAtivasStore {
    @observable erro;
    @observable carregando;
    @observable dados;

    constructor() {
        this.relatorioService = new RelatorioService();
    }

    onExportExcel = (filtro) => {
        this.erro = null;
        this.carregando = true;
        console.log(filtro)
        this.relatorioService.downloadMotsAtivasExcel(filtro).then(response => {
            fileDownload(response.data, "Relatório MOTs ativas.xlsx");

            this.carregando = false;
        }).catch(error => {
            this.erro = "Nenhum resultado encontrado";
             this.carregando = false;
        });
    }
}
